module.exports = __webpack_public_path__ + "img/CC.c3959d54.svg";